import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useLang } from "../../context/LangContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const { lang } = useLang();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (e2) {
      const d = e2.response?.data?.detail;
      if (typeof d === "string") {
        setErr(d);
      } else if (e2.code === "ECONNABORTED" || e2.message?.includes("timeout")) {
        setErr("Server unreachable. Please try again.");
      } else if (!e2.response) {
        setErr("Network error. Check your connection.");
      } else {
        setErr("Login failed");
      }
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-5" data-testid="admin-login-page">
      <form onSubmit={submit} className="card-dark p-10 w-full max-w-md" data-testid="admin-login-form">
        <div className="label-tag mb-3 slash">Admin access</div>
        <h1 className="display-font text-3xl font-black uppercase mb-8">{lang === "gr" ? "Σύνδεση" : "Sign in"}</h1>
        <input
          type="text" required placeholder="Username or email" className="input-dark mb-3"
          value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
        />
        <input
          type="password" required placeholder="Password" className="input-dark mb-5"
          value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
        />
        {err && <div className="mono-font text-xs text-[#ff003c] mb-3">{err}</div>}
        <button disabled={busy} className="btn-primary w-full justify-center mb-4" data-testid="admin-login-submit">
          {busy ? "..." : (lang === "gr" ? "Σύνδεση" : "Sign in")}
        </button>
        <div className="text-right">
          <Link
            to="/admin/forgot-password"
            className="mono-font text-xs uppercase tracking-wider text-[#a0a0aa] hover:text-[#d4ff00]"
            data-testid="forgot-password-link"
          >
            {lang === "gr" ? "Ξεχάσατε τον κωδικό;" : "Forgot password?"}
          </Link>
        </div>
      </form>
    </div>
  );
}
